import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";

import { brokerApi } from "@/shared/apis";
import { UrlManager } from "@/shared/apis/UrlManager";
import { useRouterHook } from "@/shared/hooks";

import { StyledBrokerInfo } from "./styled";

const LoginBrokerInfo: FC = () => {
    const { i18n } = useTranslation();
    const {
        globalState: { officeId },
    } = useRouterHook();

    const { data: broker } = brokerApi.useQueryBroker(officeId, {
        useErrorBoundary: false,
        suspense: false,
    });

    if (!officeId || !broker) return <></>;

    const englishVersino = i18n.language === "en";
    const separator = englishVersino ? ", " : " ";

    const zipCodeCity = [broker.zipCode, broker.city].filter(Boolean).join(separator);

    return (
        <StyledBrokerInfo data-testid="brokerLoginInfo">
            <img src={UrlManager.brokerLogo(broker.officeId)} alt="broker logo" />
            <Stack>
                <Typography mb={1} fontWeight="bold" color="var(--color-primary)" component="span">
                    {broker?.brokerName}
                </Typography>
                <span>{broker?.address}</span>
                <span>{zipCodeCity}</span>
                <span>{broker?.phone}</span>
                <span>{broker?.email}</span>
            </Stack>
        </StyledBrokerInfo>
    );
};

export default LoginBrokerInfo;
